import { SearchIcon } from '@/components/Icons'
import type { AssistTagTone } from './assist.types'
import AssistAnswerBody from './AssistAnswerBody'
import AssistTagPill from './AssistTagPill'
import type { Suggestion } from './copilot.types'

type QuestionCardProps = {
  suggestion: Suggestion
  expanded: boolean
  tagLabel: string
  tagTone: AssistTagTone
  onToggle: () => void
}

export default function QuestionCard({
  suggestion,
  expanded,
  tagLabel,
  tagTone,
  onToggle,
}: QuestionCardProps) {
  return (
    <div
      className={[
        'rounded-lg p-2.5 transition-shadow',
        expanded
          ? 'border border-slate-200 bg-white shadow-sm dark:border-[var(--border-color)] dark:bg-[var(--bg-tertiary)]'
          : 'border border-slate-200 bg-white dark:border-[var(--border-color)] dark:bg-[var(--bg-tertiary)]',
      ].join(' ')}
      data-testid={`copilot-question-${suggestion.id}`}
    >
      <button
        type="button"
        onClick={onToggle}
        className="flex w-full items-start gap-2.5 text-left"
        aria-expanded={expanded}
      >
        <SearchIcon className="mt-0.5 h-4 w-4 shrink-0 text-slate-400" />
        <span className="min-w-0 flex-1 text-[11px] leading-4 text-slate-800 dark:text-[var(--text-primary)]">
          {suggestion.question}
        </span>
        <AssistTagPill label={tagLabel} tone={tagTone} />
      </button>

      {expanded ? (
        <div className="mt-3 border-t border-slate-100 pt-3 dark:border-[var(--border-color)]">
          <AssistAnswerBody suggestion={suggestion} />
        </div>
      ) : null}
    </div>
  )
}
